var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 300,
    width: 300,
    viewBox: "-15 -15 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.4 11.289l-.355-.355c-8.801-8.8-23.2-8.8-32 0L11.6 55.378c-8.8 8.8-8.8 23.2 0 32l.355.355c8.8 8.8 23.2 8.8 31.999 0L88.4 43.288c8.799-8.8 8.799-23.199 0-31.999zm-3.838 3.838c.424.424.818.864 1.189 1.319a19.894 19.894 0 00-1.208-1.336l.019.017zm-.356-.355l.018.018c-.429-.429-.88-.825-1.336-1.208.454.371.895.766 1.318 1.19zM40.117 83.895c-6.707 6.707-17.617 6.707-24.323 0l-.355-.355c-6.707-6.706-6.707-17.617 0-24.323L37.66 36.994l.006.006 14.573-14.572 5.598-5.598c6.837-6.837 17.427-7.755 25.289-2.781-7.687-2.505-16.493-.738-22.573 5.342l-6.09 6.089-14.158 14.159L62.34 61.673 40.117 83.895z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.468 73.589l-5.041 5.041c-5.032 5.032-12.321 6.494-18.683 4.42 6.507 4.118 15.271 3.357 20.931-2.301l4.633-4.633 12.738-12.739-2.183-2.183-12.395 12.395z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPill);
export default __webpack_public_path__ + "static/media/pill.9ed1cbb2.svg";
export { ForwardRef as ReactComponent };